module.exports = __webpack_public_path__ + "img/buoyant.711e00fb.svg";